function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState, mapGetters, mapActions } from 'vuex';
export default {
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState({
    numberOfElements: function numberOfElements(s) {
      return s.pagination.numberOfElements;
    },
    selectedPageSize: function selectedPageSize(s) {
      return s.pagination.pageSize;
    }
  })), mapGetters({
    resultType: 'api/formResultType',
    paginationRequired: 'pagination/required',
    selectedPage: 'pagination/selectedPage'
  })), {}, {
    // Max value for page text input, based on the selected pageSize (not the current in the result)
    lastSelectablePage: function lastSelectablePage() {
      return Math.ceil(this.numberOfElements / this.selectedPageSize);
    },
    page: {
      get: function get() {
        return this.selectedPage;
      },
      set: function set(n) {
        this.selectPage(n);
      }
    }
  }),
  methods: _objectSpread(_objectSpread({}, mapActions({
    selectPage: 'pagination/selectPage',
    changePage: 'pagination/changePage'
  })), {}, {
    dispatchChangePage: function dispatchChangePage(page) {
      this.changePage(page);
      window.document.dispatchEvent(new CustomEvent('ncs-search', {
        detail: {
          resultType: this.resultType,
          action: 'navigation'
        }
      }));
    }
  })
};